/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Inbounds_Extraction_To_ReviewInputs */

const en_queue_inbounds_extraction_to_review = /** @type {(inputs: Queue_Inbounds_Extraction_To_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbounds with lines read to review`)
};

/**
* | output |
* | --- |
* | "Inbounds with lines read to review" |
*
* @param {Queue_Inbounds_Extraction_To_ReviewInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_inbounds_extraction_to_review = /** @type {((inputs?: Queue_Inbounds_Extraction_To_ReviewInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Inbounds_Extraction_To_ReviewInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_inbounds_extraction_to_review(inputs)
});